import React, { useEffect, useState }  from "react"
import '../layout/index.scss'
import './index.scss'
import Loader from "react-loaders"
import AnimatedLetters from "../AnimatedLetters"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCss3, faDocker, faHtml5, faJsSquare, faPython, faReact } from "@fortawesome/free-brands-svg-icons"

const About = () => {

    const [letterClass, setLetterClass] = useState('text-animate')

    useEffect(() => {
        setTimeout(() => {
            return setLetterClass('text-animate-hover')
        }, 3000)
    }, [])

    return (
        <>
        <div className='container about-page'>
            <div className="text-zone">
                <h1>
                    <AnimatedLetters
                        letterClass={letterClass}
                        strArray={"About me".split("")}
                        idx={15}
                    />
                </h1>
                <p>
                I am an ambitious and skilled Junior Web Developer with a strong foundation
                in front-end and back-end technologies. With expertise in React, Redux,
                JavaScript, Django, FastAPI, PostgreSQL, MongoDB, and system design principles,
                I am committed to delivering elegant and efficient solutions for modern web applications.
                </p>
                <p>
                As a lifelong learner, I stay updated with the latest industry trends and regularly
                participate in web development communities. This enables me to remain at the forefront of
                technological advancements, ensuring that I can provide innovative solutions that push the
                boundaries of what is possible.

                </p>
                <p>
                    And on a personal note, if I had to define myself in one sentence, that would be
                    a family person, self-proclaimed DJ and music producer, car enthusiast, and tech-obsessed!
                </p>
            </div>

            <div className='stage-cube-cont'>
                <div className='cubespinner'>
                    <div className="face1">
                        <FontAwesomeIcon icon={faHtml5} color='#F06529' />
                    </div>
                    <div className="face2">
                        <FontAwesomeIcon icon={faPython} color='#FFDE57' />
                    </div>
                    <div className="face3">
                        <FontAwesomeIcon icon={faCss3} color='#28A4D9' />
                    </div>
                    <div className="face4">
                        <FontAwesomeIcon icon={faReact} color='#5ED4F4' />
                    </div>
                    <div className="face5">
                        <FontAwesomeIcon icon={faJsSquare} color='#EFD81D' />
                    </div>
                    <div className="face6">
                        <FontAwesomeIcon icon={faDocker} color='#0DB7ED' />
                    </div>
                </div>
            </div>

        </div>
        <Loader type="semi-circle-spin" />
        </>
    )
}

export default About
